export const conditionMapTo7Ratings = (condition) => {
  switch (condition) {
    case 'FLAT':
      return 'VERY_POOR';
    case 'VERY_GOOD':
      return 'GOOD';
    case 'GOOD_TO_EPIC':
      return 'GOOD';
    default:
      return condition;
  }
};

const conditionMapToText = (condition) => condition?.replace(/_/g, ' ');

export default conditionMapToText;
